import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { CommonModule } from '@angular/common';
import { InputSwitchModule } from 'primeng/inputswitch';
import { MultiSelectModule } from 'primeng/multiselect';
import { SelectButtonModule } from 'primeng/selectbutton';
import { SliderModule } from 'primeng/slider';
import { InputTextModule } from 'primeng/inputtext';
import { InputNumberModule } from 'primeng/inputnumber';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ButtonModule } from "primeng/button";
import { ChipModule } from "primeng/chip";
import { PickListModule } from "primeng/picklist";
import { TableModule } from "primeng/table";
import { RippleModule } from "primeng/ripple";
import { CalendarModule } from "primeng/calendar";

// Services
import { GenericFormService } from './form-field/service/generic-form.service';

// Components
import { SelectButtonFieldComponent } from './form-field/select-button-field/select-button-field.component';
import { FormFieldComponent } from './form-field/form-field.component';
import { FormInputFieldComponent } from './form-field/input-field/input-field.component';
import { DropdownFieldComponent } from './form-field/dropdown-field/dropdown-field.component';
import { InputSwitchFieldComponent } from './form-field/input-switch-field/input-switch-field.component';
import { SliderFieldComponent } from './form-field/slider-field/slider-field.component';
import { RadioButtonFieldComponent } from './form-field/radio-button-field/radio-button-field.component';
import { SelectChipsComponent } from './form-field/select-chips/select-chips.component';
import { PicklistFieldComponent } from "./form-field/picklist-field/picklist-field.component";
import { TableFieldComponent } from "./form-field/table-field/table-field.component";
import { ModalTableFieldComponent } from "./form-field/modal-table-field/modal-table-field.component";
import {
	TableDataConfigurationComponent
} from "./form-field/modal-table-field/table-data-configuration/table-data-configuration.component";
import {
	CreateEditFieldValueComponent
} from "./form-field/components/create-edit-field-value/create-edit-field-value.component";
import { CalendarFieldComponent } from "./form-field/calendar-field/calendar-field.component";

const COMPONENTS = [
	FormFieldComponent,
	FormInputFieldComponent,
	DropdownFieldComponent,
	SelectButtonFieldComponent,
	InputSwitchFieldComponent,
	SliderFieldComponent,
	RadioButtonFieldComponent,
	SelectChipsComponent,
	PicklistFieldComponent,
	TableFieldComponent,
	ModalTableFieldComponent,
	TableDataConfigurationComponent,
	CreateEditFieldValueComponent,
	CalendarFieldComponent
];

@NgModule({
	imports: [
		CommonModule,
		ReactiveFormsModule,
		DropdownModule,
		AutoCompleteModule,
		InputSwitchModule,
		MultiSelectModule,
		SelectButtonModule,
		SliderModule,
		InputTextModule,
		InputNumberModule,
		FormsModule,
		RadioButtonModule,
		ButtonModule,
		ChipModule,
		PickListModule,
		TableModule,
		RippleModule,
		CalendarModule
	],
	declarations: [ ...COMPONENTS ],
	exports: [ ...COMPONENTS ],
	providers: [ GenericFormService ],
})
export class GenericFormModule {
}
